<template>
  <div class="loader-container">
    <img src="https://tanm.co.uk/assets/TANMLOGO2.PNG?url12" alt="TANM Logo" class="bouncy-logo" />
  </div>
</template>

<style scoped>
  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bouncy-logo {
    width: 150px;
    animation: bounceScale 1.5s ease-in-out infinite;
  }

  @keyframes bounceScale {
    0%, 100% {
      transform: translateY(0) scale(1);
    }

    30% {
      transform: translateY(-15px) scale(1.1);
    }

    60% {
      transform: translateY(5px) scale(0.95);
    }
  }
</style>
